module.exports = __webpack_public_path__ + "media/exports/required/assets/img/newicons/exam_status_unattempted-eea0ebc92fbaef81bb3687af141f093e.svg";